import type { ConditionalFilter, CrudFilter, LogicalFilter } from '@refinedev/core';
import { logger } from 'monitor';

const objHasKey = <T,>(obj: T, key: PropertyKey): key is keyof T => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

export const isConditionalFilter = (filter: CrudFilter): filter is ConditionalFilter => {
  return !objHasKey(filter, 'field') && objHasKey(filter, 'operator') && objHasKey(filter, 'value');
};

export const isLogicalFilter = (filter: CrudFilter): filter is LogicalFilter => {
  return objHasKey(filter, 'field') && objHasKey(filter, 'operator') && objHasKey(filter, 'value');
};

export const deconstructFilters = (
  filters: CrudFilter[] | undefined
): {
  [key: string]: string;
} => {
  if (!filters) {
    return {};
  }

  return filters.reduce((acc, filter) => {
    if (isLogicalFilter(filter)) {
      if (filter.value === null || filter.value === undefined) {
        return acc;
      }
      if (filter.field === 'search') {
        return {
          ...acc,
          [filter.field]: filter.value,
        };
      }
      return {
        ...acc,
        [`${filter.field}${filter.operator === 'eq' ? '' : `__${filter.operator}`}`]: filter.value,
      };
    }
    if (isConditionalFilter(filter)) {
      logger.error('Conditional filters are not supported yet');
      return acc;
    }
    return acc;
  }, {});
};
